import { render } from "./MarketAccountEditComponent.vue?vue&type=template&id=305b144f"
import script from "./MarketAccountEditComponent.vue?vue&type=script&lang=js"
export * from "./MarketAccountEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__